<template>
  <section class="automation-options">
    <form
      class="form"
      role="form"
    >
      <div class="row m-t-15">
        <div class="col-md-6 form-group">
          <label class="automation-options__label">{{ __('Nome') }}</label>
          <p class="automation-options__help">
            {{ __('Aqui você pode mudar o nome da sua campanha') }}
          </p>
          <input
            class="form-control"
            type="text"
            placeholder=""
            :class="{ 'is-invalid': errors[0] }"
            v-model="automation.name"
          >
          <div v-if="errors[0]" class="invalid-feedback message-feedback">
            {{ errors[0] }}
          </div>
        </div>
        <div class="col-md-6 form-group">
          <label class="automation-options__label">{{ __('Tipo de campanha') }}</label>
          <p class="automation-options__help">
            {{ __('No início você definiu o tipo, você pode alterar se quiser') }}
          </p>
          <select
            class="form-control"
            name="priority"
            v-model="automation.manual"
          >
            <option :value="true">
              {{ __('Campanha manual') }}
            </option>
            <option :value="false">
              {{ __('Campanha automatizada') }}
            </option>
          </select>
        </div>
        <div class="col-md-12 form-group">
          <label class="automation-options__label">{{ __('Categorias') }}</label>
          <p class="automation-options__help">
            {{ __('Você pode selecionar várias categorias') }}
          </p>
          <InputCategory
            :value="automation.categories"
            :model="automation.id"
            type="automation"
          />
        </div>
      </div>
      <template v-if="automation.manual == false">
        <div class="row">
          <div class="col-md-6 form-group">
            <label class="automation-options__label">{{ __('Prioridade') }}</label>
            <p class="automation-options__help">
              {{ __('Campanhas com maior prioridade terão preferência quando aplicadas.') }}
            </p>
            <select
              class="form-control automation-options__priority"
              name="priority"
              v-model="automation.priority"
            >
              <option
                v-for="priority in [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]"
                :key="priority"
                :value="priority"
                :selected="automation.priority == priority"
              >
                {{ priority }}
              </option>
            </select>
          </div>
          <div class="col-md-6 form-group">
            <label class="automation-options__label">{{ __('Executar ações somente nos dias') }}</label>
            <div class="automation-options__days">
              <span
                class="automation-options__day badge badge-default m-r-5"
                v-for="day in weekdays"
                :key="day.value"
                @click="selectDay(day.value)"
                :class="{ 'badge-success automation-options__day--active': daySelected(day.value) }"
              >{{ __(day.name) }}</span>
            </div>
            <div class="automation-options__time">
              <p class="automation-options__help">
                {{ __('Das') }}
              </p>
              <InputDateTimepicker
                type="time"
                v-model="automation.between.from"
                input-class="form-control time"
              />
            </div>
            <div class="automation-options__time">
              <p class="automation-options__help">
                {{ __('Às') }}
              </p>
              <InputDateTimepicker
                type="time"
                v-model="automation.between.to"
                input-class="form-control time"
              />
            </div>
            <p class="automation-options__help">
              {{ __('Ações serão executadas somente dentro do período selecionado.') }}
            </p>
          </div>
        </div>
      </template>
      <div class="col-md-12 text-center">
        <button
          class="btn btn-primary"
          @click="save()"
          :disabled="saving"
        >
          <span v-if="saving"><i class="fa fa-circle-o-notch fa-spin" /> {{ __('Salvando...') }}</span><span v-else>{{ __('Salvar') }}</span>
        </button>
      </div>
    </form>
  </section>
</template>

<script>
export default {
  props: ['user', 'value'],

  created () {
    this.modules = this.user.modules;

    if (this.automation.weekdays == null) {
      this.automation.weekdays = [];
    }

    if (this.automation.between == null) {
      this.automation.between = { from: null, to: null };
    }
  },

  data () {
    return {
      saving: false,
      automation: this.value,
      weekdays: [
        { name: 'segunda', value: 1 },
        { name: 'terça', value: 2 },
        { name: 'quarta', value: 3 },
        { name: 'quinta', value: 4 },
        { name: 'sexta', value: 5 },
        { name: 'sábado', value: 6 },
        { name: 'domingo', value: 0 },
      ],
      modules: [],
      errors: {},
    };
  },

  computed: {
    hasAutomation () {
      return _.indexOf(this.modules, 'automation') > -1;
    },

    hasSending () {
      return _.indexOf(this.modules, 'sending') > -1;
    },
  },

  methods: {
    selectDay (day) {
      if (this.daySelected(day)) {
        this.automation.weekdays.splice(this.automation.weekdays.indexOf(day), 1);
      } else {
        this.automation.weekdays.push(day);
      }
    },

    daySelected (day) {
      const weekdays = this.automation.weekdays || [];

      return weekdays.indexOf(day) > -1;
    },

    save () {
      this.saving = true;

      let { between } = this.automation;

      if (between.from === null || between.to === null) {
        between = null;
      }

      const data = {
        name: this.automation.name,
        manual: this.automation.manual,
        weekdays: this.automation.weekdays,
        between,
        repeat: this.automation.repeat,
        priority: this.automation.priority,
      };

      this.$http.put(`/automation/${this.automation.id}`, data)
        .then(({ body: automation }) => {
          this.saving = false;
          this.errors = {};

          this.$emit('input', automation);
          Alert.success(this.__('Opções salvas.'));
        })
        .catch((error) => {
          this.saving = false;

          if (error.status === 422) {
            this.errors = error.body.name;
          } else {
            Alert.error(__('Erro ao salvar opções. Tente novamente em instantes.'));
          }
        });
    },
  },
};
</script>

<style lang="scss">
  @import '../../../sass/variables';

  .automation-options {
    padding: 32px;

    .form-group {
      margin-bottom: 2rem;

      input:focus {
        border-color: #dc3545 !important;
      }
    }

    input,
    select {
      background-color: white;
      color: #857a98;

      &:focus {
        background-color: white;
      }
    }

    // !important :(
    &__label {
      margin: 0;
      line-height: 16px;
      margin-bottom: 4px;
      font-size: 16px !important;
      font-weight: 500 !important;
      color: $gray-dark !important;
    }

    &__help {
      font-size: 12px;
      font-weight: 400;
      color: $gray-dark;
    }

    &__time {
      width: 112px;
      margin-right: 6px;
      margin-bottom: 16px;
      display: inline-block;
    }

    &__days {
      margin: 16px 0;
    }

    &__day {
      cursor: pointer;
      height: 30px;
      padding: 0 6px;
      font-size: 12px;
      color: $gray-dark;
      font-weight: 400;
      line-height: 30px;
      margin-right: 6px;
      border-radius: 30px;
      background-color: $gray-white;

      &--active {
        color: $gray-white;
        background-color: $gray-dark;
      }
    }

    &__priority {
      width: 80px;
    }

    .is-invalid {
      background-image:none;
    }
  }
</style>
